import axios from 'axios'

export default class PaymentFiles {
  constructor(parent) {
    this.$parent = parent;
    this.list = [];
    this.loading = false;
  }

  get() {
    const self = this;
    return new Promise((resolve, reject) => {
      self.loading = true;
      axios
        .get(`/tourclient/payment/attachments?paymentId=${self.$parent.id}&_=${new Date().getTime()}`)
        .then(({data}) => {
          self.list = data.Files.map(i => {
            i.name = i.Name;
            i.url = window.location.origin + i.Url;
            return i;
          });
          resolve(self);
        }, reject)
        .finally(() => {
          self.loading = false;
        })
    });
  }

  remove(file) {
    const self = this;
    return new Promise((resolve, reject) => {
      if (self.$parent.id) {
        let id;
        if (file.Id) {
          id = file.Id
        }
        if (file.response && file.response.FileDescription && file.response.FileDescription.Id) {
          id = file.response.FileDescription.Id
        }
        axios.post(`/tourclient/Payment/RemoveFile`, `id=${id}`).then(resolve, reject);
      }
    });
  }

  prev(file) {
    const self = this;
    return new Promise((resolve, reject) => {
      if (self.$parent.id) {
        if (file.response && file.response.FileDescription && file.response.FileDescription.Url)
          window.open(file.response.FileDescription.Url);
        else
          window.open(file.url);
      }
      resolve(self);
    });
  }

  change(file) {
    if (!this.$parent.id) {
      this.list.push({name: file.name, url: file.name, file: file});
      return false;
    }
  }

  save(id) {
    const self = this;
    return new Promise((resolve, reject) => {
      if (!self.list.length) return resolve(self);
      let arr = self.list
        .map(item => {
          return new Promise((resolve1) => {
            let body = new FormData();
            body.append('paymentId', id);
            body.append('file', item.file.raw);
            let xhr = new XMLHttpRequest();
            xhr.open('POST', '/tourclient/payment/attachFile', true);

            xhr.onreadystatechange = function () {
              if (this.readyState !== 4) return;
              if (this.status !== 200) {
                resolve1();
              }
              else {
                resolve1();
              }
            };
            xhr.send(body);
          })
        });
      Promise
        .all(arr)
        .then(() => {
          resolve(self);
        })
    });
  }

  get data() {
    return {
      paymentId: this.$parent.id ? this.$parent.id : 0
    }
  }
}